export const colors: TColors = {
    "Financeiro": "#6EB834",
    "Comercial": "#3656BF",
    "Café": "#7D3600",
    "Estoque": "#1E2E6B",
    "Fiscal": "#BD3636", 
    "Produção": "#BD3636",
    "Leite": "#B2B2B2",
    "Cadastros": "#d37a14",
    "Receituário Agronômico": "#807329",
    "Fabrica": "#c56360",
}

interface TColors {
    [key: string]: string;
}

export type TMenuOptions =
    "Financeiro" |
    "Comercial" |
    "Café" |
    "Estoque" |
    "Fiscal" | 
    "Produção" |
    "Leite" |
    "Cadastros"|
    "Receituário Agronômico" |
    "Fabrica";
